import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Cookies from 'js-cookie';
import { getDefaultLanguage } from '../utils/configHelpers';

// Importar traducciones
import es from './locales/es.json';
import en from './locales/en.json';
import esHelpAndSupport from './locales/help-and-support.es.json';
import enHelpAndSupport from './locales/help-and-support.en.json';

const resources = {
  es: {
    translation: es,
    'help-and-support': esHelpAndSupport
  },
  en: {
    translation: en,
    'help-and-support': enHelpAndSupport
  }
};

// Prioridad: cookies > configuración global > fallback 'es'
const savedLanguage = Cookies.get('app-language');
const defaultLanguage = getDefaultLanguage();
const initialLanguage = savedLanguage || defaultLanguage;

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: initialLanguage,
    fallbackLng: 'es',
    interpolation: {
      escapeValue: false
    }
  });

i18n.on('languageChanged', (lng) => {
  Cookies.set('app-language', lng, { expires: 365 });
});

export default i18n;